/**
 * Detalle de un marcador (T031 · US1). El sufijo `_` la convierte en ruta hermana de
 * `/marcadores`: `_app/marcadores.tsx` no renderiza `<Outlet/>` (igual que `sedes_.$siteId`).
 */
import { createFileRoute } from '@tanstack/react-router';

import { TerminalDetailPage } from '../../features/terminals/terminal-detail-page';

export const Route = createFileRoute('/_app/marcadores_/$terminalId')({
  component: function TerminalDetailRoute() {
    const { terminalId } = Route.useParams();
    return <TerminalDetailPage terminalId={terminalId} />;
  },
});
